
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 28.455 29.871"}, attrs),
              ...rest,
            },
            children.concat([_c('defs',[_c('clipPath',{attrs:{"id":"clip-path-create-account"}},[_c('path',{attrs:{"id":"Path_22132","data-name":"Path 22132","d":"M34.172 41.1a4.657 4.657 0 004.472-4.79V22.834a4.67 4.67 0 00-4.368-4.827H21.726a4.66 4.66 0 00-4.473 4.825v13.439a4.669 4.669 0 004.382 4.829","transform":"translate(-17.253 -18.006)","fill":"#44d4fc"}})])]),_c('g',{attrs:{"id":"Group_31322","data-name":"Group 31322"}},[_c('path',{attrs:{"id":"Path_22133","data-name":"Path 22133","d":"M34.172 39.4a4.472 4.472 0 004.472-4.437V22.479a4.472 4.472 0 00-4.368-4.471H21.726a4.473 4.473 0 00-4.473 4.469v12.45a4.472 4.472 0 004.382 4.473","transform":"translate(-17.253 -18.006)","fill":"#864bf5"}}),_c('g',{attrs:{"id":"Group_31322-2","data-name":"Group 31322","transform":"translate(7.063 6.778)"}},[_c('path',{attrs:{"id":"Path_21005","data-name":"Path 21005","d":"M34.172 39.4a4.472 4.472 0 004.472-4.437V22.479a4.472 4.472 0 00-4.368-4.471H21.726a4.473 4.473 0 00-4.473 4.469v12.45a4.472 4.472 0 004.382 4.473","transform":"translate(-17.253 -18.006)","fill":"#44d4fc"}}),_c('g',{attrs:{"id":"Mask_Group_21746","data-name":"Mask Group 21746","clip-path":"url(#clip-path-create-account)"}},[_c('path',{attrs:{"id":"Path_22131","data-name":"Path 22131","d":"M34.172 41.1a4.657 4.657 0 004.472-4.79V22.834a4.67 4.67 0 00-4.368-4.827H21.726a4.66 4.66 0 00-4.473 4.825v13.439a4.669 4.669 0 004.382 4.829","transform":"translate(-24.316 -26.478)","fill":"#2cb1f7"}})])])])])
          )
        }
      }
    